export default {
	title: 'Company',
	subTitle: 'Create or edit a Company',
	content: [
		'Please add a primary and secondary color.'
	]
}



/** WEBPACK FOOTER **
 ** ./src/helpers/CompanyInfo.js
 **/